// extracted by mini-css-extract-plugin
export default {"root":"CustomUserAvatar_root__qQV2Q"};